import { Controller } from "@hotwired/stimulus"
import { MeiliSearch } from "meilisearch"

// MeiliSearch autocomplete to select plants (single or multiple)
// Values: multiple (boolean), basename, fieldname
// Targets: objectsContainer, searchContainer, input, dropdown
export default class extends Controller {
  static values = { multiple: Boolean, basename: String, fieldname: String }
  static targets = ["objectsContainer", "searchContainer", "input", "dropdown"]

  connect() {
    const env = document.querySelector('meta[name=env]')?.content || 'development'
    const client = new MeiliSearch({ host: location.protocol + '//' + location.host })
    this.plantsIndex = client.index('Plant_' + env)

    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick)
  }

  handleOutsideClick(event) {
    if (!event.target.closest("[data-plant-selector-target='dropdown']")) {
      if (this.hasDropdownTarget) this.dropdownTarget.innerHTML = ""
    }
  }

  search() {
    const q = this.inputTarget.value
    this.plantsIndex.search(q, { hitsPerPage: 20 }).then(({ hits }) => {
      if (hits.length > 0) {
        this.dropdownTarget.innerHTML = `<div>${hits.map(hit =>
          `<div class="input-search-result">
            <a class="flex items-center" href="" data-action="click->plant-selector#addObject" data-plant-id="${hit.id}" data-plant-name="${this.escapeHtml(hit.name)}" data-plant-thumb="${this.escapeHtml(hit.thumb || '')}" data-scientific-name="${this.escapeHtml(hit.scientific_name || '')}">
              <img class="data-img-xs" src="${this.escapeHtml(hit.thumb || '')}" />
              <label class="input-search-result-name"> ${this.escapeHtml(hit.name)} <span>${this.escapeHtml(hit.scientific_name || '')}</span></label>
            </a>
          </div>`
        ).join("")}</div>`
      } else {
        this.dropdownTarget.innerHTML = ""
      }
    })
  }

  addObject(event) {
    event.preventDefault()
    const anchor = event.target.closest("[data-plant-id]")
    if (!anchor) return

    const plantId = anchor.dataset.plantId
    const plantName = anchor.dataset.plantName
    const plantThumb = anchor.dataset.plantThumb
    const index = this.objectsContainerTarget.querySelectorAll("[data-selected-object]").length

    const basename = this.multipleValue && this.basenameValue.includes("[")
      ? this.basenameValue + "[" + index + "]"
      : this.basenameValue

    const objectHtml = `<div data-selected-object>
      <div class="img-preview-container row row-between items-center p-2 mb-2">
        <div>
          <img class="data-img-xs" src="${this.escapeHtml(plantThumb)}" />
          <span class="pl-4">${this.escapeHtml(plantName)}</span>
        </div>
        <a class="btn-icon-clear-danger" data-action="click->plant-selector#removeObject" href="">
          <svg class="icon"><use href="/icons/__remixicon.sprite.svg?v=491#close-line"/></svg>
        </a>
      </div>
      <input type="hidden" name="${this.escapeHtml(basename)}${this.escapeHtml(this.fieldnameValue)}" value="${plantId}" />
    </div>`

    this.objectsContainerTarget.insertAdjacentHTML("beforeend", objectHtml)
    this.dropdownTarget.innerHTML = ""
    this.inputTarget.value = ""
    this.updateInputVisibility()
  }

  removeObject(event) {
    event.preventDefault()
    const obj = event.target.closest("[data-selected-object]")
    if (!obj) return

    const persisted = obj.dataset.persisted === "true"
    const multiple = this.multipleValue

    if (persisted && multiple) {
      // Send destroy params to backend
      const id = obj.dataset.objectId
      const basename = obj.dataset.basename
      obj.innerHTML = `<input type="hidden" name="${basename}[id]" value="${id}" />
        <input type="hidden" name="${basename}[_destroy]" value="true" />`
      obj.dataset.destroyed = "true"
    } else if (persisted && !multiple) {
      const basename = obj.dataset.basename
      const fieldname = this.fieldnameValue
      obj.innerHTML = `<input type="hidden" name="${basename}${fieldname}" />`
      obj.dataset.destroyed = "true"
    } else {
      obj.remove()
    }
    this.updateInputVisibility()
  }

  updateInputVisibility() {
    if (!this.hasInputTarget) return
    const visibleObjects = this.objectsContainerTarget.querySelectorAll("[data-selected-object]:not([data-destroyed='true'])")
    if (this.multipleValue || visibleObjects.length === 0) {
      this.searchContainerTarget.style.display = ""
    } else {
      this.searchContainerTarget.style.display = "none"
    }
  }

  escapeHtml(str) {
    if (!str) return ""
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
